
















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import PoLinePhysicalSerial from "../../store/entities/receive-physicals/receive-physical"
import moment from "vue-moment";
import _ from 'lodash';
@Component
export default class ViewOrSelectSerial extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  @Prop({ type: String, default: '' }) sku: String;
  @Prop({ type: String, default: '' }) productName: String;
  @Prop({ type: Array, default: ()=>[] }) serialNosReceived: Array<PoLinePhysicalSerial>;
  @Prop({ type: Array, default: ()=>[] }) serialNosAvailable: Array<PoLinePhysicalSerial>;
  @Prop({ type: Number, default: 0 }) orderQty: number;
  @Prop({ type: Number, default: 0 }) selectQty: number;
  @Prop({ type: Number, default: 0 }) lineId: number;
  @Prop({ type: Boolean, default: false}) canReceivePhysical : boolean;

  isSelectAll : boolean = false;
  title: string = '';
  selectedQty : number = 0;
  cancel() {
    this.$emit("input", false);
  }
  created() {}
  save() {
    this.$emit('update:selectedserialNos', this.serialNosAvailable)
    this.$emit('update:lineIdSelected', this.lineId);
    this.$emit("save-success");
    this.$emit("input", false);
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    } else {
        this.title = `${this.sku} - ${this.productName}`;
        this.selectedQty = this.selectQty;
        if(this.serialNosReceived.length === 0){
          this.isSelectAll = true;
          this.onSelectAllSerial();
        }
        
    }
  }

  onSelectAllSerial(){
    this.selectedQty = this.isSelectAll ? this.selectQty : 0;
    _.forEach(this.serialNosAvailable, (item) => {
        item.isReceived = this.isSelectAll;
    });
  }

  onCheckSerialChange(){
    this.selectedQty = this.selectQty;
    this.isSelectAll = true;
    _.forEach(this.serialNosAvailable, (item) => {
        if(!item.isReceived){
          this.selectedQty -= 1;
          this.isSelectAll = false;
        }
          
    });
  }
}


